import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a "Save X%" badge, based on the selected
 * variant's compare-at price. Listens for variant update events so the
 * saving refreshes when the customer picks a different variant.
 */
class SavingsBadge extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadge);
  }

  /**
   * Updates the badge.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadge = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadge = event.detail.data.html.querySelector(`savings-badge[data-block-id="${this.dataset.blockId}"]`);
    if (!newBadge) return;

    morph(this, newBadge, { childrenOnly: true });
  };
}

if (!customElements.get('savings-badge')) {
  customElements.define('savings-badge', SavingsBadge);
}
